import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from "react-datepicker";
import { Delete, Visibility, Download, Store, Add } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import {
  AddCircle,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  Trash,
} from "iconsax-react";
import CustomPagination from "../../Utils/CustomPagination";
import LogModal from "./LogModal";
import * as XLSX from "xlsx";
import { useLocation } from "react-router-dom";

function List(props) {
  const [itemList, setItemList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [showExtendModal, setShowExtendModal] = useState(false);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: "EMP Id",
      selector: (row) => row.employeeId,
    },
    {
      name: "Created Date",
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Status",
      selector: (row) => {
        if (row.status === "1") return "Approved";
        if (row.status === "2") return "Rejected";
        return "Pending";
      },
    },
    {
      name: "Employee Name",
      selector: (row) => `${row.emp_first_name} ${row.emp_last_name}`,
    },
    {
      name: (
        <div>
          Direct Pop Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    {
      name: (
        <div>
          Action <br />
        </div>
      ),
      center: true,
      cell: (row) => (
        <>
          {/* {utils.hasPermission(
                primaryMenuRes,
                "Batch Release",
                "batch_release.create"
              ) && (
                <> */}
          {/* {row?.status == "0" && ( */}
          <RB.Button
            className="btn btn-flat me-1"
            title="Pop & Gift Request"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>

          {utils.hasPermission(
            primaryMenuRes,
            primaryMenuRes,
            "Direct Pop",
            "direct_pop.delete",
          ) && (
            <>
              {String(userProfile?.employeeId) === String(row.request_by) && (
                <RB.Button className="btn-flat" onClick={showDelete(row)}>
                  <Trash />
                </RB.Button>
              )}
            </>
          )}
          {/* )}
                </>
              )} */}
        </>
      ),
    },
  ];

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.logs);
    setShowLogModal(true);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const isBM = useMemo(() => {
    if (!primaryMenuRes) return null; // not ready yet
    return utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");
  }, [primaryMenuRes]);

  // const isBM = utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");
  useEffect(() => {
    if (isBM === null) return; // wait until permission resolved
    getItemList();
  }, [page, id, isBM]);

  // useEffect(() => {
  //   getItemList();
  // }, [page, id,isBM]);

  const getItemList = () => {
    const endpoint = isBM
      ? "/meeting/popupgift/list-popupgift-bm"
      : "/meeting/popupgift/list";
    utils
      .callAPI(
        "get",
        `${endpoint}?id=${id || ""}&page=${page}&per_page=${countPerPage}`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setItemList(res);
          if (id) {
            const found = res.result.find(
              (item) => Number(item.id) === Number(id),
            );
            if (found) {
              props.onChange({
                mode: "view",
                rowData: found,
              });
            }
          }
        } else {
          setItemList([]);
        }
      })
      .catch((err) => {
        setItemList([]);
      });
  };

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/meeting/popupgift?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getItemList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDownload = () => {
    utils
      .callAPI("get", `/meeting/popupgift/list?page=0&per_page=0`)
      .then((res) => {
        const allRequests = Array.isArray(res?.result) ? res.result : [];
        if (!allRequests.length) return;

        const dataForExcel = allRequests.flatMap((request) => {
          const createdDate = request.createdAt
            ? moment(request.createdAt).format("DD-MM-YYYY")
            : "";

          const employeeName = `${request.emp_first_name || ""} ${
            request.emp_last_name || ""
          }`.trim();

          const employeeId = request.employeeId || "";

          const reportingManager = `${request.rm_first_name || ""} ${
            request.rm_last_name || ""
          }`.trim();

          const description = request.description || "";

          // New columns
          const city = request.emp_city_name || "";
          const district = request.emp_district_name || "";
          const state = request.emp_state_name || "";

          // Convert status
          let statusText = "Pending";
          if (request.status === "1") statusText = "Approved";
          if (request.status === "2") statusText = "Rejected";

          const items = Array.isArray(request.req_items)
            ? request.req_items
            : [];

          // Calculate Total Amount
          const totalAmount = items.reduce((sum, item) => {
            const value = Number(item?.total || 0);
            return sum + (isFinite(value) ? value : 0);
          }, 0);

          // If no items, still create one row
          if (items.length === 0) {
            return [
              {
                "Created Date": createdDate,
                "Employee Name": employeeName,
                "Employee ID": employeeId,
                "Material Item": "N/A",
                Qty: 0,
                Description: description,
                Price: 0,
                "Total Amount": 0,
                Reporting: reportingManager,
                City: city,
                District: district,
                State: state,
                Status: statusText,
              },
            ];
          }

          // Rows with items
          return items.map((item, index) => {
            const qty = Number(item?.qty || 0);
            const price = Number(item?.price || 0);

            return {
              "Created Date": createdDate,
              "Employee Name": employeeName,
              "Employee ID": employeeId,
              "Material Item": item.item_name || "",
              Qty: qty,
              Description: description,
              Price: price,
              "Total Amount": index === 0 ? totalAmount : "", // Total only once
              Reporting: reportingManager,
              City: city,
              District: district,
              State: state,
              Status: statusText,
            };
          });
        });

        // Updated Header Order
        const headerOrder = [
          "Created Date",
          "Employee Name",
          "Employee ID",
          "Material Item",
          "Qty",
          "Description",
          "Price",
          "Total Amount",
          "Reporting",
          "City",
          "District",
          "State",
          "Status",
        ];

        const ws = XLSX.utils.json_to_sheet(dataForExcel, {
          header: headerOrder,
          skipHeader: false,
        });

        ws["!cols"] = [
          { wch: 14 }, // Created Date
          { wch: 25 }, // Employee Name
          { wch: 12 }, // Employee ID
          { wch: 25 }, // Material Item
          { wch: 8 }, // Qty
          { wch: 40 }, // Description
          { wch: 12 }, // Price
          { wch: 14 }, // Total Amount
          { wch: 22 }, // Reporting
          { wch: 18 }, // City
          { wch: 18 }, // District
          { wch: 18 }, // State
          { wch: 12 }, // Status
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Material Report");

        const ts = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", "_")
          .replace(/:/g, "-");

        XLSX.writeFile(wb, `Direct_Pop.xlsx`);
      })
      .catch((err) => {});
  };

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(
              primaryMenuRes,
              "Direct Pop",
              "direct_pop.create",
            ) && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
            <a
              href
              className={`${
                itemList.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
          </div>
          <RB.Card.Header></RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Direct Pop",
              "direct_pop.view",
            ) && (
              <DataTable
                columns={columns}
                data={itemList.result}
                highlightOnHover
                responsive
                pagination
                paginationServer
                paginationTotalRows={itemList.total}
                paginationPerPage={countPerPage}
                paginationComponentOptions={{
                  noRowsPerPage: true,
                }}
                stripedpaginationComponent={() => (
                  <CustomPagination
                    currentPage={page}
                    totalRows={itemList.total}
                    rowsPerPage={countPerPage}
                    onPageChange={handlePageChange}
                  />
                )}
                onChangePage={(page) => setPage(page)}
                persistTableHead
                customStyles={{
                  head: {
                    style: {
                      fontSize: "0.875rem", // Adjust the font size as needed
                      fontWeight: "bold", // Adjust the font weight as needed
                    },
                  },
                }}
                // subHeader
                // subHeaderComponent={subHeaderComponent}
              />
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
    </>
  );
}

export default List;
